// extracted by mini-css-extract-plugin
module.exports = {"link":"LegalConfirmation_link__ItVTU","content":"LegalConfirmation_content__lvUN9"};